import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createClinicUser } from '@/services/admin/clinicUsers';
import type { CreateClinicUserPayload } from '@/services/admin/clinicUsers';

/**
 * Mutation hook to create a clinic user (admin portal).
 * Invalidates clinic detail and list queries on success.
 */
export const useCreateClinicUserMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ siteType, data }: { siteType: string; data: CreateClinicUserPayload }) =>
      createClinicUser(siteType, data),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'clinics'] });
      queryClient.invalidateQueries({ queryKey: ['admin', 'clinics', variables.data.clinic_id] });
      queryClient.invalidateQueries({ queryKey: ['site-admin', 'clinic-detail', variables.data.clinic_id] });
    },
  });
};
